module.exports = __webpack_public_path__ + "img/key-name-stand.jpg";